import React from "react";


class Modal extends React.Component {
    state = {
        opacity: 1,
        showModal: false,
        maxWidth: 600
    }

    open = (cb) => {
        this.showModal(cb)
    }

    close = (cb) => {
        this.hideModal(cb)
    }

    hideModal = (cb) => {
        // document.body.classList.remove("body-no-sroll")
        window.removeEventListener("keydown", this.keyPress)
        if (this.state.showModal) {
            this.setState({ closing: true })

            if (this.props.onHide) {
                this.props.onHide()
            }

            setTimeout(() => {
                this.setState({ showModal: false }, () => {
                    if (cb) {
                        cb()
                    }

                })
            }, 500);
        }
    }

    showModal = (cb) => {

        if (!this.state.shoshowModal) {
            window.addEventListener("keydown", this.keyPress)

            this.setState({ showModal: true, closing: false })
            // setTimeout(() => {
            //     document.body.classList.add("body-no-sroll")
            // }, 50);
            if (cb) {
                cb()
            }
        }
    }

    keyPress = (e) => {
        if (e?.keyCode == 27) {
            this.hideModal()
        }
    }

    componentDidMount() {
        if (this.props.maxWidth) {
            this.setState({ maxWidth: this.props.maxWidth })
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.maxWidth != prevProps.maxWidth) {
            this.setState({ maxWidth: this.props.maxWidth })
        }
    }

    componentWillUnmount() {
        window.removeEventListener("keydown", this.keyPress)
        if (this.state.showModal) {
            // document.body.classList.remove("body-no-sroll")
        }
    }

    onScroll = () => {
        if (this.props.onScroll) {
            this.props.onScroll()
        }
    }


    render() {
        if (this.state.showModal) {
            return (
                <div className={'modal br-10 ' + (this.props.centerMode ? ' flexcc ' : '') + (this.props.fullScreen ? ' fullscreen' : '') + (this.state.closing ? ' closing' : '')} onClick={() => { if (!this.props.lockOverlay) { this.hideModal() } }}>

                    <div onScroll={() => this.onScroll()} className={" modalContent " + this.props.modalContentClassName} style={{ paddingBottom: 0, overflow: this.props.noScroll ? "hidden" : 'auto' }} onClick={() => { if (!this.props.lockOverlay) { this.hideModal() } }}>
                        
                        <div className={" w-100 " + (this.props.className)} style={{ maxWidth: this.state.maxWidth, marginTop: this.props.fullScreen ? '0px' : '5%', borderTopLeftRadius: 8, marginBottom: this.props.marginBottom ?? null }} onClick={(e) => e.stopPropagation()}>
                            {this.props.children}

                            <div className="clearfix" onClick={() => this.hideModal()} style={{ height: 50 }}>
                                <div></div>
                                <div></div>
                            </div>

                        </div>
                    </div>

                    {!this.props.hideCloseBut && (
                        <button className="flexcc blur-back" style={{ position: 'absolute', top: 15, right: 15, zIndex: 20, backgroundColor: '#00000010', borderRadius: 30, width: 30, height: 30 }} onClick={() => { this.hideModal() }}>
                            <img src="/images/close.svg" style={{ width: 14, height: 14, filter: 'invert(100%)' }} />
                        </button>
                    )}
                    {/* <div className="clearfix" >
                        <div></div>
                        <div></div>
                    </div> */}
                </div>
            );
        } else {
            return (
                <div></div>
            )
        }
    }
}





const contentStyle = {


    // padding: 30
    // box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
    // -webkit-animation-name: animatetop;
    // -webkit-animation-duration: 0.4s;
    // animation-name: animatetop;
    // animation-duration: 0.4s
}

export default Modal;
